import { getCoverageIframeSrc } from "@helpers";
import React from "react";
import styled from "styled-components";

const Iframe = styled.iframe`
  box-shadow: 0 4px 15px 0 rgba(18, 18, 82, 0.2);
  width: 100%;
`;

const NetworkPageIframe = () => {
	const name = "WEB - network page - coverage checker iframe";
	const iframeSrc = getCoverageIframeSrc();

	return (
		<>
			<Iframe
				id="coverage-iframe"
				allow="geolocation *;"
				src={iframeSrc}
				height="50"
				frameBorder="0"
				title={name}
				data-gtm-cta-position={name}
				data-gtm-cta-text={iframeSrc}
				scrolling="no"
				allowfullscreen
			/>
		</>
	);
};

export default NetworkPageIframe;
